import { render, staticRenderFns } from "./PrimaryText.vue?vue&type=template&id=9d255436&scoped=true&"
var script = {}
import style0 from "./PrimaryText.vue?vue&type=style&index=0&id=9d255436&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d255436",
  null
  
)

export default component.exports